import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import type { ActionIconProps } from '@mantine/core';
import { ActionIcon } from '@mantine/core';
import { useRouter } from '@tanstack/react-router';

export const LBBackButton = ({
  children,
  className,
  ...props
}: ActionIconProps) => {
  const router = useRouter();
  return (
    <ActionIcon
      {...props}
      variant='transparent'
      onClick={() => router.history.back()}
    >
      <ArrowLeftIcon color='gray' height={24} width={24} />
    </ActionIcon>
  );
};
